import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthGateway} from "../../application/gateway/AuthGateway";

@Injectable({
  providedIn: 'root'
})
export class SelectedFlowGuard implements CanActivate {

  constructor(private _authService: AuthGateway, private router: Router) {
  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const profile = this._authService.getUser()?.profileType;
    const selectedFlow = localStorage.getItem('_selected_flow');

    if (profile === 'Exporter' || profile === 'Importer') {
      return selectedFlow
        ? true
        : this.router.createUrlTree(['/flow-selection']);
    }

    return true;
  }
}